/**
 * Bookings Tab Content Component
 *
 * Contains all charts, tables, and visualizations specific to the Bookings tab.
 * Based on the design showing: Sales attribution, Top services, Refunds, Chargebacks, etc.
 */

import React from 'react';
import { MetricsGrid } from '../MetricsGrid';
import { AvgOrderValueChart } from '../Charts/Bookings/AvgOrderValueChart';
import { RevenuePerStaffChart } from '../Charts/Bookings/RevenuePerStaffChart';
import { TotalBookingsChart } from '../Charts/Bookings/TotalBookingsChart';
import { BookingStatusTable } from '../Tables/Bookings/BookingStatusTable';
import { DonutChartsContainer } from '../Charts/Bookings/DonutChartsContainer';
import type { MetricData } from '../../types/DashboardTypes';
import styles from './TabContent.module.scss';

interface BookingsTabContentProps {
    metrics: MetricData[];
}

export const BookingsTabContent: React.FC<BookingsTabContentProps> = ({ metrics }) => {
    return (
        <div className={styles.tabContent}>
            {/* Metrics Grid */}
            <MetricsGrid metrics={metrics} />
            {/* Main Charts Section */}
            <div className={styles.chartsSection}>
                {/* Booking Status Table */}
                <div className={styles.tableContainer}>
                    <BookingStatusTable />
                </div>

                {/* Donut Charts */}
                <div className={styles.chartContainer}>
                    <DonutChartsContainer />
                </div>
            </div>
            {/* Analytics Row */}
            <div className={styles.analyticsRow}>
                {/* Average Order Value Chart */}
                <div className={styles.smallChartContainer}>
                    <AvgOrderValueChart />
                </div>

                {/* Revenue Per Staff Chart */}
                <div className={styles.smallChartContainer}>
                    <RevenuePerStaffChart />
                </div>

                {/* Total Bookings Chart */}
                <div className={styles.smallChartContainer}>
                    <TotalBookingsChart />
                </div>
            </div>
            Leader Board Section
            <div className={styles.leaderboardSection}>
                <div className={styles.tablePlaceholder}>
                    <h3>Leader Board (Net Sales)</h3>
                    <p>Searchable table with location rankings and performance metrics</p>
                </div>
            </div>
        </div>
    );
};
